var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditprimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.699,
    viewBox: "0 0 20 20.699",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Edit-icon-primary",
    d: "M9.552,24.7A1.592,1.592,0,0,1,8,23.146V5.552a1.489,1.489,0,0,1,.466-1.087A1.489,1.489,0,0,1,9.552,4h8.8l6.21,6.21v4.036H23.006v-3H17.314V5.552H9.552V23.146h7.762V24.7Zm0-1.552v0Zm13.868-5.77.724.724L19.9,22.344v1.32h1.32l4.243-4.243.724.724L21.635,24.7H18.867V21.93Zm2.768,2.768L23.42,17.376,25,15.8a.75.75,0,0,1,1.087,0l1.682,1.682a.75.75,0,0,1,0,1.087Z",
    transform: "translate(-8 -4)",
    fill: "#227c9d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditprimary);
export default __webpack_public_path__ + "static/media/Editprimary.90c7a62abeb82229697f63e9ae4916d1.svg";
export { ForwardRef as ReactComponent };